import ModalComponent from "../../components/modals";
import SimpleTable from "../../components/tables/simpleTable";
import { riskHelpConfig } from "./riskHelpData";

const ModalComponentRiskHelp = ({ openModal, handleClose, helpId }) => {
  const config = riskHelpConfig[helpId] || { title: "", columns: [], data: [] };

  return (
    <ModalComponent open={openModal} handleClose={handleClose} title={config.title}>
      <SimpleTable data={config.data} columns={config.columns} />
    </ModalComponent>
  );
};

export default ModalComponentRiskHelp;
